import { noStoreFetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { collectionObjectApiPath } from '@/utils/collection-object'

export default function useSoldEscrows(slug: any) {
	return useSwr(slug ? `${API_URL}/${collectionObjectApiPath(slug)}/sold-escrows` : null, noStoreFetcher, {
		refreshInterval: 15_000
	})
}
